import { Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { FormProps } from '@rjsf/core';
import enLocale from 'date-fns/locale/en-US';
import frLocale from 'date-fns/locale/fr-CA';
import { useIntl } from 'react-intl';
import Form from 'views/components/forms';
import GridTemplate from './templates/GridTemplate';
import DatePickerWidget from './widgets/DatePickerWidget';

export default function JsonFormContainer<T>({ children, ...props }: FormProps<T>) {
  const intl = useIntl();

  return (
    <LocalizationProvider adapterLocale={intl.locale === 'fr' ? frLocale : enLocale} dateAdapter={AdapterDateFns}>
      <Form {...props} widgets={{ DateWidget: DatePickerWidget }} ObjectFieldTemplate={GridTemplate}>
        {children && <Box mt={3}>{children}</Box>}
      </Form>
    </LocalizationProvider>
  );
}
